
  export default {
    name: 'teaching',
    props: ['teachingData'],
  };
